module.exports = __webpack_public_path__ + "img/chat.21e82dbd.png";